import { Component, input, OnInit } from '@angular/core';
import {
	FormBuilder,
	FormControl,
	FormGroup,
	FormsModule,
	ReactiveFormsModule,
} from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GroupValidationModule } from 'src/lib/templates/layout/group-validation/group-validation.module';
import { FormControlWrapper } from 'src/lib/types/forms.def';
import { commonValidators } from 'src/lib/utilities/forms';
import { protectedPaginationTableConfigurationDefaultName } from '../../core/internal-pagination-table.interface';
import { IPaginationTable } from '../../core/pagination-table.interface';

export interface PaginationTableConfigurationEdit {
	name: string;
	create: boolean;
	copy: boolean;
}

@Component({
	selector: 'ae-pagination-table-configuration-edit-modal',
	templateUrl: './pagination-table-configuration-edit-modal.component.html',
	styleUrls: ['./pagination-table-configuration-edit-modal.component.scss'],
	imports: [FormsModule, GroupValidationModule, ReactiveFormsModule],
})
export class PaginationTableConfigurationEditModalComponent<
	T,
> implements OnInit {
	readonly pgTable = input.required<IPaginationTable<T>>();
	readonly name = input.required<string | null>();
	readonly create = input.required<boolean>();

	public editForm: FormGroup<
		FormControlWrapper<PaginationTableConfigurationEdit>
	>;

	constructor(
		public activeModal: NgbActiveModal,
		private fb: FormBuilder,
	) {}

	ngOnInit(): void {
		this.editForm = this.fb.group<
			FormControlWrapper<PaginationTableConfigurationEdit>
		>({
			name: new FormControl(this.name(), [
				commonValidators.requiredNotEmpty,
				(control: FormControl<string>) => {
					if (control.value == null) {
						return null;
					} else if (control.value.trim() === '') {
						return { required: true };
					} else if (
						this.pgTable().userPreferences.savedConfigurations.find(
							(x) =>
								x.name.toLowerCase().trim() ===
								control.value.toLowerCase().trim(),
						)
					) {
						return { duplicate: true };
					} else if (
						control.value.trim() ===
						protectedPaginationTableConfigurationDefaultName
					) {
						return { protected: true };
					} else return null;
				},
			]),
			create: new FormControl(this.create()),
			copy: new FormControl(true),
		});
	}

	public dismiss = () => {
		this.activeModal.dismiss();
	};

	public save = () => {
		const value = this.editForm.value;
		value.name = value.name.trim();
		this.activeModal.close(value);
	};
}
